import * as React from 'react';
import { render } from 'react-dom';

import UnsubscribeCard, { IUnsubscribeCardProps } from './components/unsubscribe_card/unsubscribe_card';

import './legacy/index.css';

interface ISubscriptionBundle {
  UnsubscribeCard: typeof UnsubscribeCard;
}

function loadBundle(): Promise<ISubscriptionBundle> {
  return new Promise((resolve, reject) => {
    require.ensure([
      './components/unsubscribe_card/unsubscribe_card',
    ], () => {
      resolve({
        UnsubscribeCard: require('./components/unsubscribe_card/unsubscribe_card').default,
      });
    });
  });
}

export default function initSubscription() {
  //tslint:disable-next-line:no-any
  (window as any).renderEmailTotalUnsubscribeCard = (element: Element, props: IUnsubscribeCardProps) => {
    loadBundle()
      .then(({ UnsubscribeCard }) => {
        render(<UnsubscribeCard {...props} />, element);
      });
  };
}



// WEBPACK FOOTER //
// ./src/bundles/subscription/index.tsx